<template>
</template>

<script>
</script>
<template>
	<div class="erji">
		<div class="container">
			<div class="main">
				<div class="service">
					<div class="title-00">
						<h1 class="fl">{{titleName}}</h1>
						<div class="clear"></div>
					</div>
					<div class="service-list">
						<dl>
							<dd v-for="(item,index) in serviceList" :key="index">
								<a :href="item.url" target="_blank" class="service-list-item">
									<!-- <img src="/images/nav-ico5.png" alt=""> -->
									<template v-if="item.image != null">
										<img :src="icoURL+'storage/'+item.image" alt="">
									</template>
									<template v-else>
										<img src="/images/nav-ico5.png" alt="" >
									</template>
									<h1>{{item.name}}</h1>
								</a>
							</dd>
						</dl>
						<div class="clear"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
	  name: 'service',
		data(){
			return{
				titleName:"",
				serviceList:[]
			}
		},
		methods: {
			//请求分类信息
			res_menusClass(e){
				this.axios.get('/api/menus/class?id='+e)
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
								this.titleName = response.data.reslut.name;
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			//请求办事服务子栏目
			res_service(e){
				this.axios.get('/api/menus/parentNumber?id='+e)
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							this.serviceList = response.data.reslut
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
		},
		created() {
			// console.log('service',this.$route)
			this.res_service(this.$route.query.category_id);
			this.res_menusClass(this.$route.query.category_id);
		},
		mounted(){
		
		}
	}
</script>

<style>
</style>